import styled from 'styled-components';

export const Hero = styled.div`
  min-width: 320px;
  max-width: 375px;
  width: 100%;
`;
